__turbopack_context__.v({
  "className": "mediumll_e08cb2d9-module__HxlI7G__className",
  "variable": "mediumll_e08cb2d9-module__HxlI7G__variable",
});
